import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CoreService {

  menuOpen = true;

  constructor() { }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }
}
